import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';

function App() {
   const [open, setOpen] = useState(false);
   useState(()=>{
    setOpen(true);
   },[]);
  return (    
    <div className="min-h-screen">
      <Header />
      
      <main>
        <Hero />        
        <CallMeDialog  open={open}  onClose={() => setOpen(false)} />
        {/* Intro Section */}
        <section className="py-24 bg-black">
          <div className="container mx-auto px-4 text-center">
            <div className="max-w-4xl mx-auto">
              <i className="fas fa-crown text-gold text-4xl mb-8"></i>
              <h2 className="text-4xl md:text-5xl font-serif text-white mb-8 leading-tight">
                Authentic Ayurveda for the <span className="text-gold italic">Modern King</span>
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed mb-12">
                We don't just sell supplements; we restore confidence. Our products are formulated using sacred Ayurvedic texts, 
                blended with modern understanding to provide you with the energy, endurance, and power you deserve.
              </p>
              
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                {[
                  { icon: 'fa-leaf', label: '100% Organic' },
                  { icon: 'fa-shield-halved', label: 'GMP Certified' },
                  { icon: 'fa-user-doctor', label: 'Expert Approved' },
                  { icon: 'fa-heart', label: 'Side Effect Free' }
                ].map((item, i) => (
                  <div key={i} className="flex flex-col items-center">
                    <div className="w-16 h-16 rounded-full glass flex items-center justify-center text-gold mb-4 group hover:bg-gold hover:text-black transition-all">
                      <i className={`fas ${item.icon} text-2xl`}></i>
                    </div>
                    <span className="text-[10px] uppercase tracking-widest text-gray-400 font-bold">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <ProductSection />
        <AboutSection />

        {/* Testimonial Preview */}
        <section className="py-24 bg-black relative">
          <div className="container mx-auto px-4 md:px-8 text-center">
             <div className="max-w-2xl mx-auto glass p-12 rounded-3xl border-gold/20">
                <div className="flex justify-center space-x-1 text-gold mb-6">
                  {[...Array(5)].map((_, i) => <i key={i} className="fas fa-star text-xs"></i>)}
                </div>
                <p className="text-xl italic text-white mb-8">
                  "Arvind Mera Sathi has completely changed my perspective on health. The AMS Body Boost gave me energy levels I haven't felt since my 20s. Truly life-changing results!"
                </p>
                <div className="flex items-center justify-center space-x-4">
                  <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center text-gold font-bold">RK</div>
                  <div className="text-left">
                    <h5 className="text-white font-bold text-sm">Rajesh Kumar</h5>
                    <p className="text-gray-500 text-xs">Verified Customer</p>
                  </div>
                </div>
             </div>
          </div>
        </section>

        {/* CTA Banner */}
        <section className="py-20 relative overflow-hidden">
          <div className="absolute inset-0 bg-gold"></div>
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="w-full h-full" style={{ backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
          </div>
          <div className="container mx-auto px-4 md:px-8 relative z-10 text-center">
            <h2 className="text-3xl md:text-5xl font-serif text-black mb-8">Ready to Reclaim Your Power?</h2>
            <button className="bg-black text-white px-12 py-5 font-bold uppercase tracking-[0.2em] hover:bg-white hover:text-black transition-all shadow-2xl">
              Shop The Collection
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );  
}

export default App;
